import * as React from 'react';
import {Component, useEffect, useState} from "react";
import {Route, BrowserRouter, Routes} from "react-router-dom";
import Homepage from "./Homepage";
import Page404 from "./page404";
import Pishfactor from "./Pishfactor/Pishfactor";
import './App.css';
import Login from "./auth/Login";
import "./fonts/font.css"
import EmployList from "./Employs/EmployList";
import FactorList from "./Factor/FactorList";
import ShowFactor from "./Factor/ShowFactor";
import OrderList from "./Order/OrderList";
import Showlog from "./log/Showlog";
import axios from "axios";
import FinancialReports from "./FinancialReports";
import Download from "./Download";

const App = () => {
    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;
    return (
        <BrowserRouter>
            <Routes>
                <Route>
                    <Route path="/" element={<Homepage isMobile={isMobile}/>}/>
                    <Route index path="factors" element={<Pishfactor isMobile={isMobile}/>}/>
                    <Route index path="employslist" element={<EmployList/>}/>
                    <Route index path="factors" element={<FactorList/>}/>
                    <Route index path="log" element={<Showlog isMobile={isMobile}/>}/>
                    <Route index path="factors/:factor_key" element={<ShowFactor isMobile={isMobile}/>}/>
                    <Route index path="orders" element={<OrderList/>}/>
                    <Route index path="financial_reports" element={<FinancialReports isMobile={isMobile}/>}/>
                    <Route index path="download" element={<Download/>}/>
                    <Route path="login" element={<Login/>}/>
                    <Route path="*" element={<Page404/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
export default App;
